import { render, staticRenderFns } from "./TableBase.vue?vue&type=template&id=055f8da3&"
import script from "./TableBase.vue?vue&type=script&lang=js&"
export * from "./TableBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports